import classNames from 'classnames';
import { TBackgroundDataItem, canvasBackgroundContext } from '../../../context/canvasBackgroundContext';
import styles from './BaseColors.module.css';
import { useContext } from 'react';
import { Box, Grid, Typography } from '@mui/material';

interface IBaseColors {
    onSelect?: () => void;
    keyProp: number;
}

export const BaseColors = (item: TBackgroundDataItem & IBaseColors) => {
    const { keyProp, colors, premColors, groupName, price, premPrice, onSelect = () => { return false;}} = item;

    const { backgroundData, setBackgroundData } = useContext(canvasBackgroundContext);
    const handleChoose = (image: any, imageName: string, isPrem: boolean = false) => {
        backgroundData.items[keyProp].selectedImg = image;
        backgroundData.items[keyProp].isPrem = isPrem;
        setBackgroundData({
            img: image,
            backgroundColor: backgroundData.backgroundColor,
            name: imageName,
            price: !isPrem ? price : price + premPrice,
            groupName: groupName,
            isSeamless: backgroundData.isSeamless,
            isSeamlessMode: backgroundData.isSeamlessMode,
            items: backgroundData.items,
        });
        onSelect();
    };

    return (
        <div>
            <Box p="10px 5px">
                <Typography fontWeight="bold" fontSize={'20px'}>{groupName}</Typography>
                <Typography fontWeight="bold">Стандартные цвета</Typography>
                <Typography fontSize="small" sx={{ color: 'var(--light-font-color)' }}>
                    {price} р./м2
                </Typography>
            </Box>

            <Grid display="grid" gridTemplateColumns="repeat(5, 1fr)">
                {colors.map(color => {
                    return (
                        <div
                            key={color.name}
                            className={classNames(styles.container, styles.textureContainer)}
                            onClick={() => handleChoose(color.img, color.name)}
                        >
                            <div
                                className={classNames(styles.imageWrap, color.img === backgroundData.img && styles.imageWrapSelected)}>
                                <div className={classNames(styles.imageContainer, styles.textureImageContainer)}>
                                    <img src={color.img} alt={color.name} className={classNames('texture_image')}/>
                                    <Box
                                        position="relative"
                                        zIndex="1"
                                        fontSize=".65rem"
                                        sx={{
                                            color: 'var(--white)',
                                            background: 'var(--black)',
                                            position: 'absolute',
                                            left: '0',
                                            bottom: '0',
                                            p: '0 3px'
                                        }}
                                    >
                                        {color.name}
                                    </Box>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Grid>

            {premColors && premColors.length >= 1 && (
                <div>
                    <Box p="10px 5px">
                        <Typography fontWeight="bold">Премиум цвета</Typography>
                        <Typography fontSize="small" sx={{ color: 'var(--light-font-color)' }}>
                            + {premPrice} р./м2
                        </Typography>
                    </Box>
                    <Grid display="grid" gridTemplateColumns="repeat(5, 1fr)">
                        {premColors.map(color => {
                            return (
                                <div
                                    key={color.name}
                                    className={classNames(styles.container, styles.textureContainer)}
                                    onClick={() => handleChoose(color.img, color.name, true)}
                                >
                                    <div
                                        className={classNames(styles.imageWrap, color.img === backgroundData.img && styles.imageWrapSelected)}>
                                        <div
                                            className={classNames(styles.imageContainer, styles.textureImageContainer)}>
                                            <img src={color.img} alt={color.name}
                                                 className={classNames('texture_image')}/>
                                            <Box
                                                position="relative"
                                                zIndex="1"
                                                fontSize=".65rem"
                                                sx={{
                                                    color: 'var(--white)',
                                                    background: 'var(--black)',
                                                    position: 'absolute',
                                                    left: '0',
                                                    bottom: '0',
                                                    p: '0 3px'
                                                }}
                                            >
                                                {color.name}
                                            </Box>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Grid>
                </div>
            )}
        </div>
    );
};
